<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 256 256"
    fill="currentColor"
    :width="size"
    :height="size"
    aria-hidden="true"
    focusable="false"
  >
    <path :d="path" />
  </svg>
</template>

<script>
// Relative import (not the `@/` alias): the pre-commit hook lints newly ADDED
// files with `import/no-unresolved` as an error and has no alias resolver.
import { PHOSPHOR_REGULAR_PATHS, PHOSPHOR_REGULAR_NAMES } from './phosphor-regular-paths'

/**
 * Renders one Phosphor "regular" (lined) glyph inline, so it inherits the
 * surrounding text colour through `fill="currentColor"`. Decorative by design —
 * it is always `aria-hidden`, so every call site must carry its own visible
 * label or `aria-label`.
 */
export default {
  name: 'PhosphorIcon',
  props: {
    name: {
      type: String,
      required: true,
      validator: (value) => PHOSPHOR_REGULAR_NAMES.includes(value),
    },
    size: {
      type: [Number, String],
      default: 20,
    },
  },
  computed: {
    path() {
      return PHOSPHOR_REGULAR_PATHS[this.name]
    },
  },
}
</script>
